import React from 'react';
import { ExecutionType } from '@ydistri/api-sdk';
import { translateExecutionType } from '../../evaluationsLib';
import { styled } from 'styled-components';
import { YPICK_LABEL } from '../../../../../components/global/_constants';

const executionTypeDescriptions: { type: ExecutionType; description: string }[] = [
  {
    type: ExecutionType.PickAndPack,
    description: `Data collected using ${YPICK_LABEL} application. Most accurate results.`,
  },
  {
    type: ExecutionType.Integration,
    description: 'Computed from data provided by the customer.',
  },
  {
    type: ExecutionType.Heuristic,
    description: 'Computed heuristically.',
  },
];

const DtBold = styled.dt`
  font-weight: bold;
`;

/**
 * List all enum items translated to human-readable form with descriptions.
 */
const CalculationInfoDataSourceTooltip: React.FC = () => {
  return (
    <div>
      <dl>
        {executionTypeDescriptions.map(({ type, description }) => (
          <React.Fragment key={type}>
            <DtBold>{translateExecutionType(type)}</DtBold>
            <dd>{description}</dd>
          </React.Fragment>
        ))}
      </dl>
    </div>
  );
};

export default CalculationInfoDataSourceTooltip;
